import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { NavService } from '../../service/nav.service';
import { BRAND } from '../../service/organization.services';
import { RsaService } from '../../service/rsa.service';
import { CommonModule } from '@angular/common';    

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.scss']
})
export class Header2Component implements OnInit {

  public breadcrumbs;
  public title: string;
  public currentParrent = ''
  public currentChild = ''
  public segment = 0;
  public USER_TYPE;
  public ARTWORK_APPROVE_FLAG;
  public BRAND = BRAND;
  constructor(private activatedRoute: ActivatedRoute,public navServices: NavService ,public router:Router, public rsaService: RsaService) { 

    // this.navServices.viewSubject.subscribe(data=>{
    //   console.log(data);
    //   this.segment = data;
    // })

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .pipe(map(() => this.activatedRoute))
    .pipe(map((route) => {
      while (route.firstChild) {
        route = route.firstChild;
      }
      return route;
    }))
    .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
    .subscribe(route => {      
      const snapshot = this.router.routerState.snapshot;
      const title = route.snapshot.data.title;
      const hideBreadCrumbs = route.snapshot.data.hideBreadCrumbs;
      //console.log('HERE',route.snapshot.url,route.parent.snapshot.url,route.snapshot.data.menu);
      const currentParrent = route.parent.snapshot.url.length>0?route.parent.snapshot.url[0].path:'';
      const currentChild =route.snapshot.url.length>0? route.snapshot.url[0].path:'';
      const currentSegment = route.snapshot.data.menu?route.snapshot.data.menu:0;
      const parent = route.parent.snapshot.data.breadcrumb;
      const child = route.snapshot.data.breadcrumb;
      this.breadcrumbs = {};
      // this.title = title;
      this.currentParrent = currentParrent;
      this.currentChild = currentChild;
      this.segment = currentSegment ;
      // if(['order','finance','packing'].includes(this.currentParrent)){
      //   this.segment = 2;
      // }
      // else{
      //   this.segment = 1;
      // }
      // this.breadcrumbs = {
      //   parentBreadcrumb: parent,
      //   childBreadcrumb: child
      // };
    });

  }

  ngOnInit(): void {
    this.USER_TYPE = this.rsaService.decrypt(localStorage.getItem("6"));
    this.ARTWORK_APPROVE_FLAG = JSON.parse(this.rsaService.decrypt(localStorage.getItem("2")))?.USER?.ARTWORK_APPROVE_FLAG;
  }

}
